export const CDN_BASE = "https://cdn.symphonya.eu/";

const MEWSE_PREFIX_RE = /^https?:\/\/(?:www\.)?mewse\.ro\/images\/produse\//i;

export function getLegacySiteUrl(): string {
  if(typeof process !== "undefined" && process.env.NEXT_PUBLIC_LEGACY_SITE_URL) {
    return process.env.NEXT_PUBLIC_LEGACY_SITE_URL.replace(/\/$/, "");
  }
  if(typeof process !== "undefined" && process.env.NEXT_PUBLIC_SITE_URL) {
    return process.env.NEXT_PUBLIC_SITE_URL.replace(/\/$/, "");
  }
  return "https://www.zaaaz.eu";
}

function defaultProductImage(): string {
  return `${getLegacySiteUrl()}/images/default.png`;
}

/** Strip accidental mewse.ro wrapper around an absolute CDN URL. */
function unwrapMewsePrefix(value: string): string {
  let v = value.trim();
  while(MEWSE_PREFIX_RE.test(v)) {
    v = v.replace(MEWSE_PREFIX_RE, "");
  }
  return v.trim();
}

/**
 * Resolve product image path/URL.
 * DB may store full Symphonya CDN URLs or legacy relative filenames.
 * Never prefix absolute URLs with mewse.ro.
 */
export function productImageUrl(filename: string, _opts?: {w?: number; h?: number; zc?: number}): string {
  const raw = unwrapMewsePrefix(filename || "");
  if(!raw) return defaultProductImage();
  if(/^https?:\/\//i.test(raw)) return raw;
  if(raw.startsWith("//")) return `https:${raw}`;
  const path = raw.replace(/^\//, "");
  if(path.startsWith("images/_products/") || path.startsWith("_products/")) {
    const rel = path.startsWith("images/") ? path : `images/${path}`;
    return `${CDN_BASE}${rel}`;
  }
  // Legacy bare filenames — no mewse host; fall back to site default
  return defaultProductImage();
}

/** Normalize API/legacy URLs to a direct image URL (strips timthumb + mewse wrap). */
export function productImageFromUrl(url: string, _opts?: {w?: number; h?: number; zc?: number}): string {
  if(!url) return productImageUrl("");
  let cleaned = unwrapMewsePrefix(url);
  if(cleaned.includes("timthumb.php")) {
    try {
      const q = cleaned.includes("?") ? cleaned.slice(cleaned.indexOf("?") + 1) : "";
      const src = new URLSearchParams(q).get("src");
      if(src) cleaned = unwrapMewsePrefix(decodeURIComponent(src));
    } catch {
      /* fall through */
    }
  }
  if(/^https?:\/\//i.test(cleaned) || cleaned.startsWith("//")) {
    return cleaned.startsWith("//") ? `https:${cleaned}` : cleaned;
  }
  return productImageUrl(cleaned);
}
